// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"709b2af10088591fdf27","883":"ea21c2ce112ae5c8bf2f"}[chunkId] + ".js";
};